import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';
import StringMask from 'string-mask';
import get from 'lodash/get';
import set from 'lodash/set';

const LOTTERY_CONTACT_CONTEXT = 'contact';
const INQUIRY_CONTACT_CONTEXT = 'inquiryContacts';

const DRAFT = 'DRAFT';
const DEFAULT_CONTACT = {
  phone: '',
  ext: '',
};

const contactFields2Object = (contactList) => {
  // eslint-disable-next-line no-param-reassign
  contactList.groups = contactList.groups.map((group) => {
    // eslint-disable-next-line no-param-reassign
    group.entries = group.entries.map((entry) => set(entry, 'fields', appHelpers.getFieldsFromEntry(entry)));
    return group;
  });
  return contactList;
};

const contactFields2Array = (contactList) => {
  // eslint-disable-next-line no-param-reassign
  contactList.groups = contactList.groups.map((group) => {
    // eslint-disable-next-line no-param-reassign
    group.entries = group.entries.map((entry) => set(entry, 'fields', appHelpers.setFieldsToEntry(entry.fields)));
    return group;
  });
  return contactList;
};

const extractDefaultContactPhone = (contactList) => {
  const formatter = new StringMask(DepsService.config.phoneMaskExt);
  const phone = get(contactList, 'properties.phone', DEFAULT_CONTACT.phone);
  const ext = get(contactList, 'properties.ext', DEFAULT_CONTACT.ext);
  return ext ? `${formatter.apply(phone)} (${ext})` : formatter.apply(phone);
};

const getLotteryContactsUrl = (home, secondHandApproval) => {
  if (!home && secondHandApproval) return DepsService.rest.cms.contacts.second.url;
  return DepsService.rest.cms.contacts.first.url;
};

export const fetchLotteryContacts = async ({ home, secondHandApproval, jurisdictionId }) => {
  const url = getLotteryContactsUrl(home, secondHandApproval);
  const queryParams = { locale: '*' };
  const urlParams = { jurisdictionId };
  const path = 'cms.contacts';

  const response = await DepsService.restSrv.list(LOTTERY_CONTACT_CONTEXT, url, queryParams, urlParams, path);
  const contact = {
    draft: response.versionType === DRAFT,
    contactList: contactFields2Object(response),
    defaultContactPhone: extractDefaultContactPhone(response),
  };
  return contact;
};

export const discardLotteryContactsChanges = async (jurisdictionId) => {
  const { url } = DepsService.rest.contact.discard;
  const queryParams = {};
  const urlParams = { jurisdictionId };

  const response = await DepsService.restSrv.update(LOTTERY_CONTACT_CONTEXT, url, queryParams, urlParams);
  return response;
};

export const publishLotteryContactsChanges = async ({ secondHandApproval, jurisdictionId, contactList }) => {
  const url = getLotteryContactsUrl(false, secondHandApproval);
  const queryParams = contactFields2Array(contactList);
  const urlParams = { jurisdictionId };

  const response = await DepsService.restSrv.update(LOTTERY_CONTACT_CONTEXT, url, queryParams, urlParams);
  return response;
};

export const fetchInquiryContacts = async (queryParams) => {
  const { url } = DepsService.rest.contact.inquiryContacts;
  const urlParams = {};

  return DepsService.restSrv.list(INQUIRY_CONTACT_CONTEXT, url, queryParams, urlParams);
};

export const updateInquiryContact = async (queryParams, urlParams) => {
  const { url } = DepsService.rest.contact.inquiryContact.email;

  return DepsService.restSrv.update(INQUIRY_CONTACT_CONTEXT, url, queryParams, urlParams);
};

export const sendContact = async (contactUsModel, isLoggedIn) => {
  if (isLoggedIn) {
    const { url } = DepsService.rest.contact.send;
    const { ...queryParams } = contactUsModel;

    return DepsService.restSrv.create(LOTTERY_CONTACT_CONTEXT, url, queryParams);
  }
  else { 
    const { url } = DepsService.rest.contact.sendAnonymous;
    const { captchaToken, ...queryParams } = contactUsModel;
    const urlParams = captchaToken ? { captchaToken } : {};

    return DepsService.restSrv.create(LOTTERY_CONTACT_CONTEXT, url, queryParams, urlParams);
  }
}


// WEBPACK FOOTER //
// ./src/modules/contact/resources/contact.api.js